import React from 'react'
import CommentsMainComponentContainer from 'redux/containers/pages/comments/CommentsMainComponentContainer'

const CommentsMain = (props) => <CommentsMainComponentContainer {...props} />

export default CommentsMain
